/* Swipe hint: a row of evenly spaced right-pointing arrows under the Interior tiles,
   telling shoppers the row scrolls sideways. Only shows when the row actually overflows,
   and fades out once they reach the end. */
(() => {
  const css = document.createElement('style');
  css.textContent =
    '.swh{display:flex;justify-content:space-between;align-items:center;margin:10px 2px 4px;pointer-events:none;transition:opacity .35s ease}' +
    '.swh[hidden]{display:none}' +
    '.swh.done{opacity:0}' +
    '.swh svg{width:16px;height:16px;flex:none;color:#e2262c;opacity:.25;animation:swh 1.6s ease-in-out infinite}' +
    '@keyframes swh{0%,100%{opacity:.25;transform:translateX(0)}35%{opacity:1;transform:translateX(3px)}}' +
    '@media (prefers-reduced-motion:reduce){.swh svg{animation:none;opacity:.7}}' +
    '.itab .hhead{gap:12px}.itab .hhead a{white-space:nowrap;flex:none}';
  document.head.appendChild(css);

  const N = 7; // number of arrows
  const arrow = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 3 10.5 8l-5 5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function attach(row) {
    if (row.__swh) return; row.__swh = 1;
    const h = document.createElement('div');
    h.className = 'swh';
    h.setAttribute('aria-hidden', 'true');
    h.innerHTML = Array.from({ length: N }, (_, i) => arrow.replace('<svg ', '<svg style="animation-delay:' + (i * 0.12).toFixed(2) + 's" ')).join('');
    row.after(h);
    const upd = () => {
      const over = row.scrollWidth - row.clientWidth > 4;
      h.hidden = !over;
      h.classList.toggle('done', over && row.scrollLeft + row.clientWidth >= row.scrollWidth - 8);
    };
    row.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd);
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(row);
    upd();
  }

  // Interior section heading
  const retitle = () => document.querySelectorAll('.itab .hhead h2').forEach(h => {
    const t = h.firstChild;
    if (t && t.nodeType === 3 && t.textContent.trim() === 'Interior') t.textContent = 'Build the interior your style';
  });
  const scan = () => { retitle(); document.querySelectorAll('.itab .itiles').forEach(attach); };
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
